import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

const FILTER_PROPS = {
  height: "40px",
  borderRadius: "20px",
};

export const SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton = () => {
  return (
    <Column>
      <LoadingSkeleton width={getSpacing(120)} height={getSpacing(20)} />
      <Spacer width="2x" />
      <LoadingSkeleton width={getSpacing(160)} height={getSpacing("5x")} />
      <Spacer size="1x" />
      <LoadingSkeleton width="50%" height={getSpacing(20)} />
      <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "4x" }} />
      {/* Filter row */}
      <div className="flex flex-row gap-x-2 overflow-x-hidden">
        <LoadingSkeleton width="44px" {...FILTER_PROPS} />
        <LoadingSkeleton width="44px" {...FILTER_PROPS} />
        {/* Mobile shows only one filter loading */}
        <LoadingSkeleton {...FILTER_PROPS} width="120px" />
        {/* Tablet adds two more */}
        <div className="hidden md:flex md:flex-row">
          <LoadingSkeleton {...FILTER_PROPS} width="120px" />
          <Spacer width="2x" />
          <LoadingSkeleton {...FILTER_PROPS} width="120px" />
        </div>
        {/* Desktop adds one more */}
        <div className="hidden lg:flex lg:flex-row">
          <LoadingSkeleton {...FILTER_PROPS} width="120px" />
        </div>
      </div>
      <Spacer height="2x" />
    </Column>
  );
};
